import { RelationAggregateOperation, VariableDefinition } from '@/explore/types';

import { ensureValidUseOfVariablesInFilterCondition } from './filter';

export const ensureValidUseOfVariablesInRelationAggregate = (
  operation: RelationAggregateOperation,
  definitions: VariableDefinition[],
): RelationAggregateOperation => {
  return operation.parameters.filter !== undefined
    ? {
        ...operation,
        parameters: {
          ...operation.parameters,
          filter: ensureValidUseOfVariablesInFilterCondition(
            operation.parameters.filter,
            definitions,
          ),
        },
      }
    : operation;
};
